import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
)

// Storage bucket name for Engitronix
export const STORAGE_BUCKET = 'engitronix'

// Storage helpers
export const getPublicUrl = (path: string) => {
  const { data } = supabase.storage.from(STORAGE_BUCKET).getPublicUrl(path)
  return data.publicUrl
}

export const uploadFile = async (
  path: string,
  file: File
) => {
  const { data, error } = await supabase.storage
    .from(STORAGE_BUCKET)
    .upload(path, file, {
      cacheControl: '3600',
      upsert: true,
    })

  if (error) throw error
  return data
}

export const deleteFile = async (path: string) => {
  const { error } = await supabase.storage.from(STORAGE_BUCKET).remove([path])
  if (error) throw error
}

// Table prefix for Engitronix
export const TABLE_PREFIX = 'engitronix_'

// Helper to get table name with prefix
export const getTable = (name: string) => `${TABLE_PREFIX}${name}`
